﻿import {useGeocodeByAddress} from "./useGeocodeByAddress";

// Los Angeles, CA, USA - default fallback location
export const DEFAULT_INIT_LAT = parseFloat("34.0522342");
export const DEFAULT_INIT_LNG = parseFloat("-118.2436849");
export const DEFAULT_CITY = "Los Angeles";
export const DEFAULT_STATE = "CA";
export const DEFAULT_COUNTRY = "US";

export const useDefaultLocation = () => {
    const address = `${DEFAULT_CITY}, ${DEFAULT_STATE}, ${DEFAULT_COUNTRY}`;
    const {geocodedAddress} = useGeocodeByAddress({address, region: DEFAULT_COUNTRY});

    return {
        defaultLocation: geocodedAddress
    }
}
